// FIXME This file need refactor and has technical depth

import { useEffect, useRef, useState } from "react";
import { Note, Page } from "../../../../helbest";
import Steps from "../Steps/Steps";
import HeaderBack from "../../../../helbest/HeaderBack/HeaderBack";
import { Button, Input as AntdInput, Card, Select } from "antd";
import { CloseCircleFilled } from "@ant-design/icons";
import styles from "./NewService.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  set_is_coupon,
  set_services_odometer_value,
  set_services_phone_number,
  set_services_user_car,
  set_services_skip_step,
  reset_qr_service_state,
  reset_service_state,
} from "../../../../store/actions/services_actions";
import SelectCar from "./SelectCar/SelectCar";
// import SelectNewCar from "./SelectNewCar/SelectNewCar";
import SelectName from "./SelectName/SelectName";
import { API } from "../../../../request/api";
import { BaseURL } from "../../../../base/env";
import QrCodeIcon from "../../../../assets/svg/qr-code.svg";
import MobileIcon from "../../../../assets/svg/mobile.svg";
import { ReactComponent as UploadIcon } from "../../../../assets/svg/upload-plus.svg";
import Compressor from "compressorjs";
import heic2any from "heic2any";
// import SliderDotsIcon from "../../../../assets/svg/slider-dots.svg";
import SubmitServiceBannerEN from "../../../../assets/images/base/submit-service-en.png";
import SubmitServiceBannerAR from "../../../../assets/images/base/submit-service-ar.png";

import CanadaSlider from "../../../../assets/images/base/canada-banner.png";

import { ReactComponent as PhoneIcon } from "../../../../assets/svg/external-drive.svg";
import { ReactComponent as UserIcon } from "../../../../assets/svg/user.svg";

import { ReactComponent as ActiveOrderIcon } from "../../../../assets/svg/box-tick.svg";
import { ReactComponent as CarServiceIcon } from "../../../../assets/svg/car-service.svg";
import { ReactComponent as OdometerIcon } from "../../../../assets/svg/odometer.svg";
import { ReactComponent as EditPenIcon } from "../../../../assets/svg/edit-2.svg";
import { ReactComponent as TurkeyIcon } from "./../../../../assets/svg/country-flags/turkey.svg";
import { ReactComponent as UnitedArabIcon } from "./../../../../assets/svg/country-flags/united-arab.svg";
import { ReactComponent as CanadaIcon } from "./../../../../assets/svg/country-flags/canada.svg";
import { ReactComponent as OmanIcon } from "./../../../../assets/svg/country-flags/oman.svg";
import { ReactComponent as BackIcon } from "./../../../../assets/svg/category-back.svg";

// import IllustrationIcon from "../../../../assets/svg/Illustration.svg";
import { Comma } from "../../../../base/utils";
import { useTranslation } from "react-i18next";
// import AccessDeniedError from "../../../components/ErrorComponents/AccessDeniedError";
// import Input from "../../../components/Input/Input";
import { useLangNavigate } from "../../../../hooks/useLangNavigate";
// import QRCodeReaderPage from "./QRCodeReader/QRCodeReaderPage";
import Loading from "../../../components/Loading/Loading";
import { countries } from "../../../../constants/countries-code";
import { formatCarDisplay } from "../../../../base/utils";





const isHeicFile = (file) => {
  const type = (file.type || "").toLowerCase();
  const name = (file.name || "").toLowerCase();
  // iOS/Safari sometimes reports an empty MIME type for HEIC, so check the extension too
  return (
    type === "image/heic" ||
    type === "image/heif" ||
    name.endsWith(".heic") ||
    name.endsWith(".heif")
  );
};



const NewService = () => {
  const navigate = useLangNavigate();
  const dispatch = useDispatch();
  const Login = useSelector((state) => state.Login);
  const ServiceSlice = useSelector((state) => state.Services);
  const { country } = useSelector((state) => state.Region);
  const [firstPage, setFirstPage] = useState(
    () => !ServiceSlice.phone_number
  );
  const [selectVehicle, setSelectVehicle] = useState(false);
  const [selectNewVehicle, setSelectNewVehicle] = useState(false);
  const [selectName, setSelectName] = useState(false);
  const [loading, setLoading] = useState(
    () => !!ServiceSlice.phone_number
  );
  const [selectedUserCar, setSelectedUserCar] = useState({
    userCarSelected: {
      user_car_id: null,
      user_car_name: "",
    },
    typeSelected: {
      type_id: null,
      type_name: "",
    },
    brandSelected: {
      brand_id: null,
      brand_name: "",
    },
    modelSelected: {
      model_id: null,
      model_name: "",
    },
    yearSelected: null,
  });
  const [mustRefetchUserInfo, setMustRefetchUserInfo] = useState(false);

  const { t, i18n } = useTranslation();
  const SubmitServiceBanner = i18n.language === "ar"
    ? SubmitServiceBannerAR
    : SubmitServiceBannerEN;

  const [countryCode, setCountryCode] = useState(countries[0].code);
  const countryCodeSelected = countries.find((i) => i.code === countryCode);
  const [userInfo, setUserInfo] = useState({
    username: "",
    full_name: "",
    cars: [],
    is_coupon: null,
  });
  const [phoneNumber, setPhoneNumber] = useState("");
  const [vehicle, setVehicle] = useState("");
  const [odometerValue, setOdometerValue] = useState("");
  const [isLoadingLocation, setIsLoadingLocation] = useState(false);
  const [lng, setLng] = useState(null);
  const [ltd, setLtd] = useState(null);
  const odometerInputRef = useRef(null);
  const platePhotoInputRef = useRef(null);
  const [platePhoto, setPlatePhoto] = useState(null);
  const [platePhotoPreview, setPlatePhotoPreview] = useState(null);
  const [isExistingPlatePhoto, setIsExistingPlatePhoto] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [convertingPlatePhoto, setConvertingPlatePhoto] = useState(false);

  const check_user = () => {
    if (!Login.is_login) {
      navigate("/login/d/");
    }
  };

  const setUserLocation = () => {
    setIsLoadingLocation(true);

    if (!navigator.geolocation) {
      Note.error(t("address_map.errors.geolocation_not_supported"));
      setIsLoadingLocation(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const latitude = Number(position.coords.latitude.toFixed(4));
        const longitude = Number(position.coords.longitude.toFixed(4));
        setLng(longitude);
        setLtd(latitude);
        navigate("scan-qr", { state: { lng: longitude, ltd: latitude } });
        setIsLoadingLocation(false);
      },
      (error) => {
        let errorMessage;
        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMessage = t("address_map.errors.location_access_denied");
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage = t("address_map.errors.location_unavailable");
            break;
          case error.TIMEOUT:
            errorMessage = t("address_map.errors.geolocation_request_timeout");
            break;
          default:
            errorMessage = t("address_map.errors.location_failed");
        }

        Note.error(errorMessage);
        setIsLoadingLocation(false);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  };

  const handleScanQRAndLoacation = () => {
    setUserLocation();
  };

  // const handleChange = (event) => {
  //   const inputValue = event.target.value;
  //   const inputName = event.target.name;
  //   setState({
  //     ...state,
  //     [inputName]:
  //       inputName === "odometer_value" && /^\d*$/.test(inputValue)
  //         ? event.target.value.replaceAll(",", "")
  //         : inputValue,
  //   });
  // };

  const submitHandler = (e) => {
    e.preventDefault();

    if (!phoneNumber || phoneNumber.length < countryCodeSelected.length) {
      return Note.error(t("login.messages.mobile_invalid"));
    }
    if (!countryCode) {
      return Note.error(t("login.messages.country_code_invalid"));
    }

    setLoading(true);
    API.get
      .customerInfo(countryCode.substring(1) + phoneNumber)
      .then((response) => {
        if (response.success) {
          // Clear any leftover QR-flow state so a stale skip_step / qr_bill_id
          // from a previous QR scan never leaks into this normal flow.
          dispatch(reset_qr_service_state());

          setUserInfo(response.data);
          if (response.data.cars.length > 0) {
            dispatch(
              set_services_user_car(
                response.data.cars[response.data.cars.length - 1].user_car_id,
                response.data.cars[response.data.cars.length - 1].model_name,
                response.data.cars[response.data.cars.length - 1].year,
                response.data.cars[response.data.cars.length - 1].brand_name,
              )
            );
          } else {
            dispatch(set_services_user_car(null, "", null));
          }
          dispatch(
            set_services_phone_number(countryCodeSelected.code + phoneNumber)
          );
          setFirstPage(false);
        } else {
          Note.error(response.message);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onSubmit = async () => {
    if (!odometerValue) {
      return Note.error(t("new_service.errors.odometer_required"));
    }

  if (!ServiceSlice.user_car_id) {
    return Note.error(t("new_service.errors.vehicle_required"));
  }

    if (platePhoto) {
      setSubmitLoading(true);
      try {
        const response = await API.post.uploadPlateImage(
          ServiceSlice.user_car_id,
          countryCode + phoneNumber,
          platePhoto
        );
        if (!response.success) {
          Note.error(response.message);
          return;
        }
      } catch (err) {
        Note.error(t("new_service.errors.upload_failed"));
        return;
      } finally {
        setSubmitLoading(false);
      }
    }

    dispatch(set_is_coupon(userInfo.is_coupon));
    dispatch(set_services_odometer_value(Number(odometerValue)));

    navigate("/select-service/");
  };

  const compressPlatePhoto = (blob) => {
    return new Promise((resolve, reject) => {
      new Compressor(blob, {
        quality: 0.6,
        success(result) {
          resolve(result);
        },
        error(err) {
          reject(err);
        },
      });
    });
  };

  const convertHeicToJpeg = async (file) => {
    const converted = await heic2any({
      blob: file,
      toType: "image/jpeg",
      quality: 0.8,
    });
    // heic2any returns an array if the HEIC container has multiple images
    const jpegBlob = Array.isArray(converted) ? converted[0] : converted;
    return new File(
      [jpegBlob],
      file.name.replace(/\.(heic|heif)$/i, ".jpg"),
      { type: "image/jpeg" }
    );
  };

  const handlePlatePhotoChange = async (e) => {
    const files = e.target.files;
    if (files?.length) {
      const file = files[0];
      try {
        let workingFile = file;

        if (isHeicFile(file)) {
          setConvertingPlatePhoto(true);
          try {
            workingFile = await convertHeicToJpeg(file);
          } finally {
            setConvertingPlatePhoto(false);
          }
        }

        const compressedBlob = await compressPlatePhoto(workingFile);
        const compressed = new File(
          [compressedBlob],
          workingFile.name || "plate.jpg",
          { type: compressedBlob.type || workingFile.type || "image/jpeg" }
        );
        if (platePhotoPreview && !isExistingPlatePhoto) {
          URL.revokeObjectURL(platePhotoPreview);
        }
        setIsExistingPlatePhoto(false);
        setPlatePhoto(compressed);
        setPlatePhotoPreview(URL.createObjectURL(compressed));
      } catch (err) {
        console.log("Error processing plate photo: ", err);
        Note.error(t("new_service.errors.upload_failed"));
      }
      platePhotoInputRef.current.value = "";
    }
  };

  const handleRemovePlatePhoto = (e) => {
    e.stopPropagation();
    if (platePhotoPreview && !isExistingPlatePhoto) {
      URL.revokeObjectURL(platePhotoPreview);
    }
    setPlatePhoto(null);
    setPlatePhotoPreview(null);
    setIsExistingPlatePhoto(false);
  };

  // Header back arrow on the customer-info screen: this is a genuine
  // "start over" — full reset of the whole services slice (phone number,
  // car, odometer, order lines, coupon flag, and all QR fields), plus local
  // UI state, so the phone-entry/QR-scan screen stays showing even if this
  // component remounts later.
  const handleBackToEntry = () => {
    dispatch(reset_service_state());
    setPhoneNumber("");
    setUserInfo({
      username: "",
      full_name: "",
      cars: [],
      is_coupon: null,
    });
    setVehicle("");
    setOdometerValue("");
    setPlatePhoto(null);
    setPlatePhotoPreview(null);
    setIsExistingPlatePhoto(false);
    setFirstPage(true);
  };

  useEffect(() => {
    check_user();
    // eslint-disable-next-line
  }, [Login.is_login]);

  // Defensive safety net: a carwash QR session (skip_step: true) never
  // legitimately passes through this screen — the bill is created at scan
  // time and QRCodeReaderPage routes straight to /select-service/. If we
  // land here anyway with skip_step still true (e.g. browser back button,
  // a stray navigation), treat it as a full reset rather than showing
  // stale customer-info built from a session that shouldn't be here.
  useEffect(() => {
    if (ServiceSlice.skip_step === true) {
      dispatch(reset_service_state());
    }
    // eslint-disable-next-line
  }, []);

  // Whenever this page mounts with a phone_number already known (whether
  // from a normal phone-entry session or a skip_step:false QR scan), skip
  // the phone-entry screen and fetch customer info directly — firstPage and
  // loading are already lazily initialized to reflect this, so this effect
  // just needs to populate local state and fetch.
  useEffect(() => {
    if (!ServiceSlice.phone_number) {
      return;
    }

    const matchedCountry = countries.find((c) =>
      ServiceSlice.phone_number.startsWith(c.code)
    );
    const number = matchedCountry
      ? ServiceSlice.phone_number.slice(matchedCountry.code.length)
      : ServiceSlice.phone_number;

    if (matchedCountry) setCountryCode(matchedCountry.code);
    setPhoneNumber(number);

    // Restore odometer value if it was already entered/saved in a previous
    // visit to this screen (e.g. user went to SelectService and came back).
    if (ServiceSlice.odometer_value) {
      setOdometerValue(String(ServiceSlice.odometer_value));
    }

    // Consume skip_step (QR-only) once acted on so a later revisit to this
    // page doesn't replay QR-specific handling with stale state.
    if (ServiceSlice.skip_step !== null) {
      dispatch(set_services_skip_step(null));
    }

    API.get
      .customerInfo(
        (matchedCountry ? matchedCountry.code.substring(1) : "") + number
      )
      .then((response) => {
        if (response.success) {
          setUserInfo(response.data);
          if (response.data.cars.length > 0) {
            dispatch(
              set_services_user_car(
                response.data.cars[response.data.cars.length - 1].user_car_id,
                response.data.cars[response.data.cars.length - 1].model_name,
                response.data.cars[response.data.cars.length - 1].year,
                response.data.cars[response.data.cars.length - 1].brand_name,

              )
            );
          } else {
            dispatch(set_services_user_car(null, "", null));
          }
        } else {
          Note.error(response.message);
        }
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    return () => {
      if (platePhotoPreview && !isExistingPlatePhoto) {
        URL.revokeObjectURL(platePhotoPreview);
      }
    };
  }, [platePhotoPreview, isExistingPlatePhoto]);

  useEffect(() => {
    if (firstPage || !ServiceSlice.user_car_id || !ServiceSlice.phone_number) {
      return;
    }

    let cancelled = false;

    setPlatePhoto(null);
    setPlatePhotoPreview(null);
    setIsExistingPlatePhoto(false);

    const mobileNumber = ServiceSlice.phone_number.replace("+", "");

    API.get
      .plateImage(ServiceSlice.user_car_id, mobileNumber)
      .then((response) => {
        if (cancelled) {
          return;
        }
        if (response.success && response.data?.plate_image) {
          setPlatePhoto(null);
          setIsExistingPlatePhoto(true);
          setPlatePhotoPreview(`${BaseURL}${response.data.plate_image}`);
        }
      })
      .catch((error) => {
        console.log("Error fetching plate image: ", error);
      });

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstPage, ServiceSlice.user_car_id, ServiceSlice.phone_number]);

  useEffect(() => {
    if (!firstPage && mustRefetchUserInfo) {
      API.get
        .customerInfo(countryCode.substring(1) + phoneNumber)
        .then((response) => {
          if (response.code === 200) {
            setUserInfo(response.data);
            setMustRefetchUserInfo(false);
          }
        })
        .catch((error) => {
          console.log("Error : ", error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mustRefetchUserInfo]);

  useEffect(() => {
    const foundCountry = countries.find(
      (c) => c.country.toLowerCase() === country.toLowerCase()
    );
    if (foundCountry) setCountryCode(foundCountry.code);
  }, [country]);

  return (
    <Page
      className="bg-gray-light"
      bodyWrapperClassName={firstPage ? styles.ServicesPage : ""}
      showFooter={true}
      customHeader={
        firstPage ? (
          <HeaderBack title={t("drawer.new_service")} url={"/"} />
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              height: "48px",
              flexShrink: 0,
              boxShadow: "0px 1px 3px 0px #d5d5d540",
              alignItems: "center",
              position: "sticky",
              top: 0,
              backgroundColor: "white",
              zIndex: 102,
              padding: "4px",
            }}
          >
            <BackIcon
              style={{
                rotate: i18n.dir() === "rtl" ? "180deg" : "0",
                height: "16px",
                width: "16px",
                margin: "10px",
                cursor: "pointer",
              }}
              onClick={handleBackToEntry}
            />
            <span
              style={{
                fontSize: "18px",
                width: "100%",
                lineHeight: "unset",
                marginInlineStart: "4px",
              }}
            >
              {t("drawer.new_service")}
            </span>
          </div>
        )
      }
      extra_header={
        firstPage ? null : <Steps hasShadow />
      }
      footer={
        !firstPage ? (
          <div className="page-fixed-footer-container" >
            <Button
              type="primary"
              size="large"
              style={{
                width: "100%",
              }}
              onClick={onSubmit}
              loading={submitLoading}
              disabled={
                convertingPlatePhoto ||
                ((!odometerValue || !vehicle || !phoneNumber) &&
                  !userInfo.is_coupon)
              }
            >
              {t("common.next")}
            </Button>
          </div>
        ) : (
          <div />
        )
      }
      headerFix
      logo
      back
    >
      <div>
        {firstPage ? (
          <div className=" flex flex-column justify-center items-center relative">
            {/* <img
              src={IllustrationIcon}
              alt="illustration"
              width={220}
              height={240}
              className="mb-4"
            /> */}

            {/* -----------slider--------- */}
            <img
              src={Login.channel === "canada" ? CanadaSlider : SubmitServiceBanner}
              alt="slider"
              className={styles.silderBanner}
            />
            <div style={{ position: "relative", width: "100%" }}>
              {Login.channel !== "canada" && (
                <Card
                  bodyStyle={{ padding: "4px" }}
                  onClick={handleScanQRAndLoacation}
                >
                  <div className={styles.qrcodeCardContainer}>
                    <div className={styles.qrcodeCardContent}>
                      <p className={styles.qrcodeCardTitle}>
                        {t("new_service.qr_code.scan_button")}
                      </p>
                      {isLoadingLocation ? (
                        <Loading />
                      ) : (
                        <img src={QrCodeIcon} className={styles.LocationIcon} />
                      )}
                    </div>
                  </div>
                </Card>
              )}
            </div>

            <Card style={{ width: "100%" }} bodyStyle={{ padding: "4px" }}>
              <div className={styles.mobileCardContainer}>
                <div className={styles.mobileCardTitle}>
                  <p className="mb-3 ml-1">
                    {t("new_service.customer_mobile")}
                  </p>
                </div>
                <div className={styles.qrcodeCardContent}>
                  <form onSubmit={submitHandler} className={styles.form}>
                    <div
                      className={styles["phone-number-wrapper"]}
                      style={{
                        flexDirection:
                          i18n.dir() === "ltr" ? "row" : "row-reverse",
                      }}
                    >
                      <div className={styles["country-code-wrapper"]}>
                        <Select
                          value={countryCode}
                          onChange={(value) => setCountryCode(value)}
                          dropdownStyle={{ width: 70 }}
                          style={{ width: 120, boxShadow: "none" }}
                          prefix={
                            <countryCodeSelected.icon
                              className={styles.CountryIcon}
                            />
                          }
                          variant="filled"
                        >
                          {countries.map((countryItem) => (
                            <Select.Option
                              key={countryItem.code}
                              value={countryItem.code}
                              className={styles.SelectCountryOption}
                            >
                              {countryItem.label}
                            </Select.Option>
                          ))}
                        </Select>
                      </div>
                      <AntdInput
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        maxLength={countryCodeSelected.length}
                        placeholder={t("common.phone")}
                        className={styles.customPlaceholder}
                        pattern="[0-9]*"
                        inputMode="numeric"
                        helperText={t("login.mobileNumberHelper")}
                        variant="filled"
                        prefix={
                          <img
                            src={MobileIcon}
                            className={styles.LocationIcon}
                          />
                        }
                      />
                    </div>
                    <Button
                      loading={loading}
                      htmlType="submit"
                      // type="primary"
                      size="large"
                      className={styles.submitPhoneBtn}
                    >
                      {t("common.next")}
                    </Button>
                  </form>{" "}
                </div>
              </div>
            </Card>
          </div>
        ) : loading ? (
          <div className="text-center mt-5">
            <Loading />
          </div>
        ) : (
          <div className="py-4">
            <div
              className={`${userInfo.is_coupon === true
                ? styles.OrderFound
                : userInfo.is_coupon === false
                  ? styles.OrderNotFound
                  : styles.OrderIsPend
                } ${styles.ActiveOrder}`}
            >
              <ActiveOrderIcon />
              <span
                className={`${userInfo.is_coupon === true
                  ? styles.OrderFoundText
                  : userInfo.is_coupon === false
                    ? styles.OrderNotFoundText
                    : styles.OrderIsPendText
                  }`}
              >
                {userInfo?.is_coupon === true
                  ? t("new_service.order_found")
                  : userInfo?.is_coupon === false
                    ? t("new_service.order_not_found")
                    : t("new_service.order_pending") + "..."}
              </span>
            </div>
            <div className={`mt-4 p-4 ${styles.Input} ${styles.ServicesCard}`}>
              <p className={styles.TitleInput}>
                {t("new_service.customer_mobile")}
              </p>
              <div
                className={`${styles.Input} ${styles.NewServiceInput} mb-2 flex items-center relative`}
              >
                <PhoneIcon width={24} className="me-2" />
                <span>
                  {countryCode} {phoneNumber}
                </span>
              </div>
              <p className={styles.TitleInput}>
                {t("new_service.customer_name")}
              </p>
              <div
                className={`${styles.Input} ${styles.NewServiceInput} mb-2 flex items-center relative`}
              >
                <UserIcon width={24} className="me-2" />
                <span>
                  {userInfo.full_name}
                </span>
              </div>

              <p className={styles.TitleInput}>
                {t("new_service.customer_vehicle")}<span className={styles.RequiredMark}>*</span>
              </p>
              <div className="relative">
                <CarServiceIcon
                  className={styles.InputIcon}
                  width={24}
                />
                <AntdInput
                  name="vehicle"
                  className={`${styles.Input} ${styles.NewServiceInput}`}
                  onClick={() => setSelectVehicle(true)}
                  placeholder={t("new_service.customer_vehicle")}
                  value={
                    ServiceSlice.user_car_id
                      ? formatCarDisplay(
                        ServiceSlice.user_car_brand_name || "",
                        ServiceSlice.user_car_name || "",
                        ServiceSlice.user_car_year || "",
                        10
                      )
                      : ""
                  }
                  style={{ paddingInlineStart: 38, marginBottom: 4 }}
                  readOnly
                  title={
                    ServiceSlice.user_car_id
                      ? `${ServiceSlice.user_car_brand_name} - ${ServiceSlice.user_car_name} - ${ServiceSlice.user_car_year}`
                      : ""
                  }
                />
                <EditPenIcon
                  className={styles.InputIconRight}
                  width={24}
                  onClick={() => setSelectVehicle(true)}
                />
              </div>
              <p className={styles.TitleInput}>
                {t("new_service.odometer_value")}<span className={styles.RequiredMark}>*</span>

              </p>
              <div className="relative">
                <OdometerIcon className={styles.InputIcon} width={24} />
                <AntdInput
                  ref={odometerInputRef}
                  name="odometer_value"
                  className={`${styles.Input} ${styles.NewServiceInput}`}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value.replaceAll(",", ""))) {
                      setOdometerValue(value.replaceAll(",", ""));
                    }
                  }}
                  pattern="[0-9]*"
                  inputMode="numeric"
                  placeholder={t("new_service.odometer_placeholder_example")}
                  value={Comma(odometerValue)}
                  style={{ paddingInlineStart: 38, marginBottom: 4 }}
                />
                <EditPenIcon
                  className={styles.InputIconRight}
                  width={24}
                  onClick={() => odometerInputRef.current?.focus()}
                />
              </div>

              {/* Modals */}
              <SelectCar
                userCars={userInfo.cars}
                selectedUserCar={selectedUserCar}
                setSelectedUserCar={setSelectedUserCar}
                isVehicleSelected={selectVehicle}
                closeModal={() => setSelectVehicle(false)}
                setSelectNewVehicle={setSelectNewVehicle}
                mobileNumber={countryCode + phoneNumber}
                setMustRefetchUserInfo={setMustRefetchUserInfo}
              />
              <SelectName
                addName={(name) => setVehicle(name.model.name)}
                mobileNumber={countryCode + phoneNumber}
                isVisible={selectName}
                closeModal={() => setSelectName(false)}
                setMustRefetchUserInfo={setMustRefetchUserInfo}
              />
            </div>

            <div className={`mt-4 p-4 ${styles.Input} ${styles.ServicesCard} ${styles.PlatePhotoCard}`}>
              <p className={styles.TitleInput}>
                {t("new_service.vehicle_plate_photo")}
              </p>
              <div
                onClick={() => {
                  if (
                    userInfo.cars?.length > 0 &&
                    !submitLoading &&
                    !convertingPlatePhoto
                  ) {
                    platePhotoInputRef.current?.click();
                  }
                }}
                className={`${styles.PlatePhotoBox} ${userInfo.cars?.length > 0 ? "" : styles.PlatePhotoBoxDisabled
                  }`}
              >
                <input
                  ref={platePhotoInputRef}
                  type="file"
                  accept="image/*,.heic,.heif"
                  onChange={handlePlatePhotoChange}
                  disabled={
                    !(userInfo.cars?.length > 0) ||
                    submitLoading ||
                    convertingPlatePhoto
                  }
                  className={styles.HiddenFileInput}
                />
                {convertingPlatePhoto ? (
                  <Loading />
                ) : platePhotoPreview ? (
                  <>
                    <img
                      src={platePhotoPreview}
                      alt={t("new_service.vehicle_plate_photo")}
                      loading="lazy"
                      className={styles.PlatePhotoPreview}
                    />
                    {!submitLoading && !isExistingPlatePhoto && (
                      <div
                        className={styles.PlatePhotoRemoveBtn}
                        onClick={handleRemovePlatePhoto}
                      >
                        <CloseCircleFilled />
                      </div>
                    )}
                    {!submitLoading && isExistingPlatePhoto && (
                      <div
                        className={styles.PlatePhotoEditBtn}
                        onClick={(e) => {
                          e.stopPropagation();
                          platePhotoInputRef.current?.click();
                        }}
                      >
                        <EditPenIcon width={14} height={14} />
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    <UploadIcon className={styles.PlatePhotoIcon} />
                    <span className={styles.PlatePhotoText}>{t("new_service.upload_plate_photo")}</span>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </Page>
  );
};

export default NewService;